import React, { FunctionComponent } from 'react';

import { Stack, Typography } from '@mui/material';

import Footer from '../../image/webp_Footer.webp';
import Footer2 from '../../image/webp_Footer2.webp';
import Iphone from '../../image/Apple.png';
import Android from '../../image/Android.png';
import Huawei from '../../image/Huawei.png';
import Vk from '../../image/Vk.png';
import Tg from '../../image/Tg.png';
import {
  ANDROID_SHOP,
  APPLE_SHOP,
  HUAWEI_SHOP,
  OFERTA_URL,
  POL_SOGL_URL,
  POLIT_CONFID_URL,
  SOGL_OBR_URL,
  TG_CHANAL,
  VK_CHANAL,
  WINDOW_H,
  WINDOW_V,
} from '../../constant/constants';
import { HandleView } from '../../utils/utils';

interface Props {
  windowState: number;
}

export const LendingDivtemTextFooter: FunctionComponent<Props> = ({
  windowState,
}) => {
  const getSizePictureFona = () => {
    let widtn = window.innerWidth;
    let heghh = 588;
    if (widtn > 786) {
      widtn = 786;
    }
    if (heghh > 588) {
      heghh = 588;
    }
    widtn = (heghh * 786) / 1132;
    return `${widtn}px ${heghh}px`;
  };

  const getSizePictureFona2 = () => {
    let widtn = window.innerWidth;
    let heghh = 342;
    if (widtn > 1298) {
      widtn = 1298;
    }
    if (heghh > 342) {
      heghh = 342;
    }
    widtn = (heghh * 1298) / 685;
    return `${widtn}px ${heghh}px`;
  };

  return (
    <Stack width="100%">
      {windowState === WINDOW_V && (
        <Stack
          width="100%"
          sx={{
            background: `#1D2228`,
          }}
          spacing={1}
        >
          <Stack
            width="100%"
            height="588px"
            sx={{
              background: `url(${Footer}), #000000`,
              backdropFilter: 'blur(4.400000095367432px)',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center bottom',
              backgroundSize: `${getSizePictureFona()}`,
            }}
            spacing={1}
          >
            <Stack
              paddingLeft="36px"
              paddingTop="50px"
              paddingRight="36px"
              spacing={1}
            >
              <Stack
                width="100%"
                direction="row"
                justifyContent="space-between"
              >
                <Typography
                  width="77px"
                  fontWeight={400}
                  fontFamily="Roboto"
                  fontSize="12px"
                  letterSpacing="0.3px"
                  textAlign="left"
                  color="#FFFFFF"
                  component="text"
                >
                  Скачивайте в сторах:
                </Typography>
                <Typography
                  fontWeight={400}
                  fontFamily="Comfortaa"
                  fontSize="20px"
                  letterSpacing="0.3px"
                  textAlign="left"
                  color="#FFFFFF"
                  component="text"
                >
                  Учи Мед
                </Typography>
              </Stack>
              <Stack width="100%" direction="row" spacing={1}>
                <Stack onClick={() => HandleView(APPLE_SHOP)}>
                  <img alt="" width="50px" height="50px" src={Iphone} />
                </Stack>
                <Stack onClick={() => HandleView(ANDROID_SHOP)}>
                  <img alt="" width="50px" height="50px" src={Android} />{' '}
                </Stack>
                <Stack onClick={() => HandleView(HUAWEI_SHOP)}>
                  <img alt="" width="50px" height="50px" src={Huawei} />{' '}
                </Stack>
              </Stack>
              <Stack
                width="100%"
                paddingTop="30px"
                direction="row"
                justifyContent="space-between"
              >
                <Typography
                  width="77px"
                  fontWeight={400}
                  fontFamily="Roboto"
                  fontSize="12px"
                  letterSpacing="0.3px"
                  textAlign="left"
                  color="#FFFFFF"
                  component="text"
                >
                  Соцсети:
                </Typography>
              </Stack>
              <Stack width="100%" direction="row" spacing={1}>
                <Stack onClick={() => HandleView(VK_CHANAL)}>
                  <img alt="" width="50px" height="50px" src={Vk} />
                </Stack>
                <Stack onClick={() => HandleView(TG_CHANAL)}>
                  <img alt="" width="50px" height="50px" src={Tg} />
                </Stack>
              </Stack>
            </Stack>
            <Stack
              paddingLeft="36px"
              paddingTop="25px"
              paddingRight="36px"
              spacing={3}
            >
              <Typography
                fontWeight={400}
                fontFamily="Roboto"
                fontSize="12px"
                letterSpacing="0.3px"
                textAlign="center"
                color="#FFFFFF"
                component="text"
                style={{
                  cursor: 'pointer',
                }}
                onClick={() => HandleView(POL_SOGL_URL)}
              >
                Пользовательское соглашение
              </Typography>
              <Typography
                fontWeight={400}
                fontFamily="Roboto"
                fontSize="12px"
                letterSpacing="0.3px"
                textAlign="center"
                color="#FFFFFF"
                component="text"
                style={{
                  cursor: 'pointer',
                }}
                onClick={() => HandleView(POLIT_CONFID_URL)}
              >
                Политика конфиденциальности
              </Typography>
              <Typography
                fontWeight={400}
                fontFamily="Roboto"
                fontSize="12px"
                letterSpacing="0.3px"
                textAlign="center"
                color="#FFFFFF"
                component="text"
                style={{
                  cursor: 'pointer',
                }}
                onClick={() => HandleView(SOGL_OBR_URL)}
              >
                Согласие на обработку персональных данных
              </Typography>
              <Typography
                fontWeight={400}
                fontFamily="Roboto"
                fontSize="12px"
                letterSpacing="0.3px"
                textAlign="center"
                color="#FFFFFF"
                component="text"
                style={{
                  cursor: 'pointer',
                }}
                onClick={() => HandleView(OFERTA_URL)}
              >
                Публичная оферта
              </Typography>
              <Stack spacing={1}>
                <Typography
                  fontWeight={400}
                  fontFamily="Roboto"
                  fontSize="10px"
                  letterSpacing="0.3px"
                  textAlign="center"
                  lineHeight="14px"
                  color="#FFFFFF80"
                  component="text"
                >
                  ООО «Медобртех»
                </Typography>
                <Typography
                  fontWeight={400}
                  fontFamily="Roboto"
                  fontSize="10px"
                  letterSpacing="0.3px"
                  textAlign="center"
                  lineHeight="14px"
                  color="#FFFFFF80"
                  component="text"
                >
                  ИНН: 1655488623
                </Typography>
                <Typography
                  fontWeight={400}
                  fontFamily="Roboto"
                  fontSize="10px"
                  letterSpacing="0.3px"
                  textAlign="center"
                  lineHeight="14px"
                  color="#FFFFFF80"
                  component="text"
                >
                  ОГРН: 1221600090700
                </Typography>
                <Typography
                  fontWeight={400}
                  fontFamily="Roboto"
                  fontSize="10px"
                  letterSpacing="0.3px"
                  textAlign="center"
                  lineHeight="14px"
                  color="#FFFFFF80"
                  component="text"
                >
                  {' '}
                </Typography>
                <Typography
                  fontWeight={400}
                  fontFamily="Roboto"
                  fontSize="10px"
                  letterSpacing="0.3px"
                  textAlign="center"
                  lineHeight="14px"
                  color="#FFFFFF80"
                  component="text"
                >
                  E-mail: artur.lisyukov.1991@gmail.com
                </Typography>
                <Typography
                  fontWeight={400}
                  fontFamily="Roboto"
                  fontSize="10px"
                  letterSpacing="0.3px"
                  textAlign="center"
                  lineHeight="14px"
                  color="#FFFFFF80"
                  component="text"
                >
                  Telegram: @uchi_med
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      )}
      {windowState === WINDOW_H && (
        <Stack
          width="100%"
          sx={{
            background: `#1D2228`,
          }}
          spacing={1}
        >
          <Stack
            width="100%"
            height="342px"
            sx={{
              background: `url(${Footer2}), #000000`,
              backdropFilter: 'blur(4.400000095367432px)',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center bottom',
              backgroundSize: `${getSizePictureFona2()}`,
            }}
            spacing={1}
          >
            <Stack paddingTop="25px" alignItems="center" spacing={1}>
              <Stack
                width="840px"
                direction="row"
                justifyContent="space-between"
              >
                <Stack spacing={4}>
                  <Typography
                    fontWeight={700}
                    fontFamily="Comfortaa"
                    fontSize="28px"
                    letterSpacing="0.3px"
                    textAlign="left"
                    color="#FFFFFF"
                    component="text"
                  >
                    Учи Мед
                  </Typography>
                  <Stack spacing={2}>
                    <Typography
                      fontWeight={400}
                      fontFamily="Roboto"
                      fontSize="12px"
                      letterSpacing="0.3px"
                      textAlign="left"
                      color="#FFFFFF"
                      style={{
                        cursor: 'pointer',
                      }}
                      component="text"
                      onClick={() => HandleView(POL_SOGL_URL)}
                    >
                      Пользовательское соглашение
                    </Typography>
                    <Typography
                      fontWeight={400}
                      fontFamily="Roboto"
                      fontSize="12px"
                      letterSpacing="0.3px"
                      textAlign="left"
                      color="#FFFFFF"
                      style={{
                        cursor: 'pointer',
                      }}
                      component="text"
                      onClick={() => HandleView(POLIT_CONFID_URL)}
                    >
                      Политика конфиденциальности
                    </Typography>
                    <Typography
                      fontWeight={400}
                      fontFamily="Roboto"
                      fontSize="12px"
                      letterSpacing="0.3px"
                      textAlign="left"
                      color="#FFFFFF"
                      style={{
                        cursor: 'pointer',
                      }}
                      component="text"
                      onClick={() => HandleView(SOGL_OBR_URL)}
                    >
                      Согласие на обработку персональных данных
                    </Typography>
                    <Typography
                      fontWeight={400}
                      fontFamily="Roboto"
                      fontSize="12px"
                      letterSpacing="0.3px"
                      textAlign="left"
                      color="#FFFFFF"
                      style={{
                        cursor: 'pointer',
                      }}
                      component="text"
                      onClick={() => HandleView(OFERTA_URL)}
                    >
                      Публичная оферта
                    </Typography>
                    <Stack spacing={1}>
                      <Typography
                        fontWeight={400}
                        fontFamily="Roboto"
                        fontSize="10px"
                        letterSpacing="0.3px"
                        textAlign="left"
                        lineHeight="14px"
                        color="#FFFFFF80"
                        component="text"
                      >
                        ООО «Медобртех»
                      </Typography>
                      <Typography
                        fontWeight={400}
                        fontFamily="Roboto"
                        fontSize="10px"
                        letterSpacing="0.3px"
                        textAlign="left"
                        lineHeight="14px"
                        color="#FFFFFF80"
                        component="text"
                      >
                        ИНН: 1655488623
                      </Typography>
                      <Typography
                        fontWeight={400}
                        fontFamily="Roboto"
                        fontSize="10px"
                        letterSpacing="0.3px"
                        textAlign="left"
                        lineHeight="14px"
                        color="#FFFFFF80"
                        component="text"
                      >
                        ОГРН: 1221600090700
                      </Typography>
                      <Typography
                        fontWeight={400}
                        fontFamily="Roboto"
                        fontSize="10px"
                        letterSpacing="0.3px"
                        textAlign="left"
                        lineHeight="14px"
                        color="#FFFFFF80"
                        component="text"
                      >
                        E-mail: artur.lisyukov.1991@gmail.com
                      </Typography>
                      <Typography
                        fontWeight={400}
                        fontFamily="Roboto"
                        fontSize="10px"
                        letterSpacing="0.3px"
                        textAlign="left"
                        lineHeight="14px"
                        color="#FFFFFF80"
                        component="text"
                      >
                        Telegram: @uchi_med
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
                <Stack spacing={2} width="170px" alignItems="end">
                  <Stack spacing={1} width="170px" alignItems="end">
                    <Typography
                      fontWeight={400}
                      fontFamily="Roboto"
                      fontSize="12px"
                      letterSpacing="0.3px"
                      textAlign="right"
                      color="#FFFFFF"
                      component="text"
                    >
                      Скачивайте в сторах:
                    </Typography>
                    <Stack
                      width="170px"
                      justifyContent="right"
                      direction="row"
                      spacing={1}
                    >
                      <Stack onClick={() => HandleView(APPLE_SHOP)}>
                        <img alt="" width="50px" height="50px" src={Iphone} />
                      </Stack>
                      <Stack onClick={() => HandleView(ANDROID_SHOP)}>
                        <img alt="" width="50px" height="50px" src={Android} />
                      </Stack>
                      <Stack onClick={() => HandleView(HUAWEI_SHOP)}>
                        <img alt="" width="50px" height="50px" src={Huawei} />{' '}
                      </Stack>
                    </Stack>
                  </Stack>
                  <Stack spacing={1} alignItems="end">
                    <Typography
                      width="77px"
                      fontWeight={400}
                      fontFamily="Roboto"
                      fontSize="12px"
                      letterSpacing="0.3px"
                      textAlign="right"
                      color="#FFFFFF"
                      component="text"
                    >
                      Соцсети:
                    </Typography>
                    <Stack width="100%" direction="row" spacing={1}>
                      <Stack onClick={() => HandleView(VK_CHANAL)}>
                        <img alt="" width="50px" height="50px" src={Vk} />
                      </Stack>
                      <Stack onClick={() => HandleView(TG_CHANAL)}>
                        <img alt="" width="50px" height="50px" src={Tg} />
                      </Stack>
                    </Stack>
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      )}
    </Stack>
  );
};
